const shop = "9bq_shop_list";

export function setShopStorage (value) {
    sessionStorage.setItem(shop, JSON.stringify(value))
}

export function getShopStorage () {
    return JSON.parse(sessionStorage.getItem(shop))
}
